<template>
  <div>
    <van-loading v-if="box.loading" size="24px" vertical class="loading">
      {{ $t("loading") }}...
    </van-loading>

    <div id="chart-wrapper" v-if="!box.loading">
      <section
        id="container-piechart"
        class="chart-section"
        :style="{
          'min-height': `${getChartMinHeight}`
        }"
      >
        <h2 class="section-title center-me">
          {{ $t("stats.charttitle words learned") }}
        </h2>
        <van-loading
          v-if="quiz_results.loading"
          size="24px"
          vertical
          class="loading"
        >
          {{ $t("loading") }}...
        </van-loading>
        <div
          v-else-if="
            quiz_results.data &&
              Object.keys(quiz_results.data).length > 0 &&
              Object.keys(quiz_results.data.counts).length > 0
          "
          style="position:relative;"
        >
          <PieChart
            :style="{
              'min-height': `${getChartMinHeight} !important;`
            }"
            class="chart-container"
            :chartdata="chartDataQuizResults"
            :options="quizResultOptions"
          />
          <span class="donut-inner">
            {{ chartDataQuizResults.datasets[0].data[1] }}%
          </span>
        </div>

        <span class="no-data" v-else>{{
          $t("stats.box quiz data not available")
        }}</span>
      </section>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import PieChart from "@/components/chart/PieChart";

function _createDefaultChartOptions(overrides) {
  const result = {
    maintainAspectRatio: false,
    responsive: true,
    legend: { display: false },
    title: { display: false },
    animation: { duration: 1700, animateScale: true, animateRotate: true }
  };

  return Object.assign({}, result, overrides);
}

export default {
  name: "BoxLearnedWordsChart",
  components: { PieChart },
  data: () => ({
    quizResultOptions: {
      ..._createDefaultChartOptions({
        cutoutPercentage: 45
      })
    },
    percentageCorrect: 0
  }),
  methods: {
    ...mapActions("vokabel", ["getBoxInformation"]),
    ...mapActions("statistics", ["fetchQuizStats"])
  },
  computed: {
    ...mapState("vokabel", ["box"]),
    ...mapState("account", ["user"]),
    ...mapState("statistics", ["quiz_results"]),

    chartDataQuizResults: function() {
      if (this.quiz_results.loading || this.quiz_results.data == {}) {
        return null;
      }

      const data = {
        labels: [
          this.$t("stats.chart wrong percentage"),
          this.$t("stats.chart correct percentage")
        ],
        datasets: [
          {
            borderColor: "rgba(0, 0, 0, 0.2)",
            borderWidth: 0.5,
            backgroundColor: ["red", "green"],
            data: []
          }
        ]
      };

      const knownPercentage = this.quiz_results.data.learnedWordsPercentage;

      data.datasets[0].data[0] = 100 - knownPercentage;
      data.datasets[0].data[1] = knownPercentage;
      return data;
    },

    getChartMinHeight: function() {
      return this.quiz_results.data &&
        Object.keys(this.quiz_results.data).length > 0 &&
        this.quiz_results.data.count > 0
        ? "300px"
        : "0";
    }
  },
  mounted() {
    // eslint-disable-next-line no-unused-vars
    this.fetchQuizStats({ box: this.box.data }).catch(err => {
      // TODO: handle API request errors
    });
  }
};
</script>

<style lang="scss">
#chart-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  padding: 0 7px;

  .no-data {
    margin-left: 16px;
    font-size: 0.9rem;
  }
  .donut-inner {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    font-size: 3rem;
    font-weight: bold;
  }
  .chart-section {
    flex: 1 1 100%;
    padding: 5px 10px;
    display: flex;
    flex-direction: column;
    max-width: 100%;
    .chart-container {
      position: relative;
      flex: 1;
    }
  }
}
</style>
